import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#171717",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "m15 7-7 7M8 14l-3-3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#171717",
      "stroke-linecap": "round",
      d: "M10 .5a9.5 9.5 0 0 1 9.5 9.5 9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 .5 10 9.5 9.5 0 0 1 10 .5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }